
<!-- .block-banner -->
 <div *ngIf="banner" class="block-banner mb-2 {{fullWidth? 'w-full-container':''}}">
    <div>
        <a *ngIf="!banner.external;else external" [routerLink]="url" [queryParams]="params" class="block-banner__body">
            <div class="block-banner__image block-banner__image--desktop"><img class="{{rounded? 'rounded-border':''}}" style="width: 100%;" [src]="image||banner.image"
                    alt=""></div>
            <div class="block-banner__image block-banner__image--mobile"><img class="{{rounded? 'rounded-border':''}}" style="width: 100%;"
                    [src]="banner.mobileImage || image||banner.image" alt=""></div>
        </a>
        <ng-template #external>
            <a [href]="banner.url? banner.url[translate.currentLang]:null" class="block-banner__body">
                <div class="block-banner__image block-banner__image--desktop"><img class="{{rounded? 'rounded-border':''}}" style="width: 100%;"
                        [src]="image||banner.image" alt=""></div>
                <div class="block-banner__image block-banner__image--mobile"><img class="{{rounded? 'rounded-border':''}}" style="width: 100%;"
                        [src]="banner.mobileImage || image||banner.image" alt=""></div>
            </a>
        </ng-template>
    </div>
</div>
<!-- .block-banner / end -->
